export default __webpack_public_path__ + "static/media/lisieux07.74af5836.jpg";